export default {
  setBasicData: (state, data) => {
    state.basic = data;
  },
  setFullData: (state, data) => {
    state.full = data;
  },
};
